export default "__VITE_ASSET__BcQgYCzI__"